export { Table } from './table';

export type { TableCellType } from './table';
